import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';





@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit
{

  @Input('notificationsData') notificationsData : any;
  @Output() toggle_notification_window_event = new EventEmitter();
  @ViewChild('closeButoon') NotificationCloseButton!: any;


  constructor(
    private cookie_s: CookieService,private router:Router
  ) { }

  ngOnInit(): void
  {


  }


  close_window()
  {
    this.toggle_notification_window_event.emit(false);
  }


  switchtoDetailsProduct(result: any)
  {

    console.log('♨️♨️♨️', result )
console.log(this.NotificationCloseButton)
    this.close_window()
   if (this.NotificationCloseButton) {
    const closeButtonElement = this.NotificationCloseButton.nativeElement;
    // Now you can use closeButtonElement and call its click method or perform other operations
    closeButtonElement.click();

  }
    // navigate to product details page
    this.router?.navigate(['products', 'product-details', result?.product_id, result?.product.name]);

  }

}
